import { jsx } from "react/jsx-runtime";
import { c as classNames } from "./index-e71f83b5.js";
import React__default from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "./utils-f8d1c624.js";
import FlashButton from "./components/atoms/buttons/FlashButton/FlashButton.js";
import { sass } from "./sass/sass.js";
import { noOp } from "./utils/noOp.js";
var _excluded = ["className", "cssModule", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  /** Add custom class */
  className: PropTypes.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function InputGroupText(props) {
  var className = props.className, cssModule = props.cssModule, _props$tag = props.tag, Tag = _props$tag === void 0 ? "span" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "input-group-text"), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
InputGroupText.propTypes = propTypes;
function FlashFormInputTextFieldModifierButtonIcon(props) {
  const { id, onClick, Icon, disabled, hideWhenDisabled = !0, inputHasFocus, analytics } = props;
  function preventInputFocusLoss(event) {
    event.preventDefault();
  }
  return /* @__PURE__ */ jsx(InputGroupText, { className: "end-1px ps-flash-100", onMouseDown: preventInputFocusLoss, children: /* @__PURE__ */ jsx(
    FlashButton,
    {
      id,
      LeadingIcon: Icon,
      color: "icon_only_default",
      removePadding: !0,
      disabled,
      onClick: inputHasFocus ? onClick : noOp,
      className: classNames({ invisible: !inputHasFocus, "opacity-0": hideWhenDisabled && disabled }),
      iconFontSize: sass.typography.flash.semantic.font.label.l.size,
      onMouseDown: preventInputFocusLoss,
      analytics
    }
  ) });
}
export {
  FlashFormInputTextFieldModifierButtonIcon as F,
  InputGroupText as I
};
//# sourceMappingURL=FlashFormInputTextFieldModifierButtonIcon-f8b9669c.js.map
